function carousel() {

	if ( $('#nitrogen-performance-map').length ) {

        let countyData;

        async function initMap() {
            const { Map } = await google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
            const center = { lat: 39.5, lng: -98.35 };

            const map = new Map(document.getElementById('nitrogen-performance-map'), {
                center: center,
                zoom: 5,
                mapId: '36af48ee210f806a'
            });

            const infoWindow = new google.maps.InfoWindow();

            for (var i = 0; i < countyData.length; i++) {
                const pinImage = document.createElement('img');
                pinImage.src = theme_vars['theme_dir'] + '/assets/img/pin.webp';
                
                const marker = new AdvancedMarkerElement({
                    map,
                    position: { lat: parseFloat(countyData[i].lat), lng: parseFloat(countyData[i].lng) },
                    content: pinImage
                });

                const contentString =
                `<div id="infoWindow">
                    <div>
                        ${countyData[i].name} County
                    </div>
                    <div>
                        <div>Plant Biomass:</div>
                        <div>${countyData[i].pb}%</div>
                    </div>
                    <div>
                        <div>Nitrogen Advantage:</div>
                        <div>${countyData[i].na}%</div>
                    </div>
                </div>`;

                marker.addListener('click', () => {
                    infoWindow.setContent(contentString);
                    infoWindow.open({
                        anchor: marker,
                        map,
                    });
                });
            }
        }

        // Add markers
        const sheetURL = 'https://docs.google.com/spreadsheets/d/1V99JJb5e4n4k8tDLJRjdDkdr5MGMQjGK2xqZXr6CPUU/gviz/tq?tqx=out:csv&sheet=countyData';
        fetch(sheetURL)
            .then((response) => response.text())
            .then((csvText) => handleResponse(csvText));

        function handleResponse(csvText) {
            countyData = csvToObjects(csvText);
            initMap();
        }
        
        function csvToObjects(csv) {
            const csvRows = csv.split('\n');
            const propertyNames = csvSplit(csvRows[0]);
            let objects = [];
            for (let i = 1, max = csvRows.length; i < max; i++) {
                let thisObject = {};
                let row = csvSplit(csvRows[i]);
                for (let j = 0, max = row.length; j < max; j++) {
                    thisObject[propertyNames[j]] = row[j];
                }
                objects.push(thisObject);
            }
            return objects;
        }
        
        function csvSplit(row) {
            return row.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map((val) => val.substring(1, val.length - 1));
        }

    }

}